import { Card, CardContent } from './ui/card'
import { Users } from 'lucide-react'
import type { CampaignDashboardData } from '@/lib/api'

type Props = {
  stats: CampaignDashboardData['stats']
  loading?: boolean
}

export function CampaignStatusCard({ stats, loading }: Props) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map(i => (
          <Card key={i}>
            <CardContent className="pt-4">
              <div className="h-8 bg-gray-200 rounded animate-pulse mb-2" />
              <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4" />
            </CardContent>
          </Card>
        ))}
      </div>
    )
  }

  const pct = (n: number) =>
    stats.total > 0 ? Math.round((n / stats.total) * 100) : 0

  const items = [
    { label: 'Total fournisseurs', value: stats.total, icon: <Users className="h-4 w-4" />, color: 'text-gray-700' },
    { label: 'Soumis', value: `${pct(stats.submitted)}%`, sub: `${stats.submitted} fournisseur${stats.submitted > 1 ? 's' : ''}`, color: 'text-green-700' },
    { label: 'En cours', value: `${pct(stats.inProgress)}%`, sub: `${stats.inProgress} fournisseur${stats.inProgress > 1 ? 's' : ''}`, color: 'text-amber-700' },
    { label: 'Non démarrés', value: `${pct(stats.notStarted)}%`, sub: `${stats.notStarted} fournisseur${stats.notStarted > 1 ? 's' : ''}`, color: 'text-gray-500' },
  ]

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {items.map(item => (
        <Card key={item.label}>
          <CardContent className="pt-4">
            <p className={`text-2xl font-bold ${item.color}`}>{item.value}</p>
            {item.sub && <p className="text-xs text-muted-foreground">{item.sub}</p>}
            <p className="text-sm text-muted-foreground mt-1">{item.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
